import { render, staticRenderFns } from "./SimilarityHighlight.vue?vue&type=template&id=a7dc14ee&scoped=true"
import script from "./SimilarityHighlight.vue?vue&type=script&setup=true&lang=js"
export * from "./SimilarityHighlight.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SimilarityHighlight.vue?vue&type=style&index=0&id=a7dc14ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dc14ee",
  null
  
)

export default component.exports